var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { InfoOutlined } from '@mui/icons-material';
import { SvgIcon } from '@mui/material';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import { setReducerState } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { REG } from '../../../utils/validationHelper';
import IssuedQtyPopup from '../../jobCard/partGridPopups/issueQuantityPopup';
import TaxDetailsPopup from '../../jobCard/partGridPopups/taxDetailsPopup';
import { getServiceTypeList, getTechnicianList, UnitOfMeasurementList, validateQuantityAndGetTax } from '../services/apiCalls';
import { JobCardKeys } from '../services/entity';
import { handleRatioDetailsPopup } from './utils';
export function usePartElements() {
    var _this = this;
    var _crud$documentDetails;
    var dispatch = useAppDispatch();
    var crud = useAppSelector(function (state) { return state.crud; });
    var partElements = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            padding: '10px',
            rowSpacing: 2,
            columnSpacing: 2,
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: 'HSNSACCode',
                    label: 'HSN Code :',
                    xs: 12,
                    disabled: true
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'ServiceTypeId',
                    label: 'Service type',
                    getListData: getServiceTypeList,
                    apiKey: 'serviceTypeList',
                    displayExpr: 'DisplayName',
                    valueExpr: 'id',
                    xs: 12,
                    disabled: true
                    // required: true
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'UnitOfMeasurementId',
                    label: 'UOM',
                    getListData: UnitOfMeasurementList,
                    apiKey: 'UnitOfMeasurementList',
                    displayExpr: 'Name',
                    valueExpr: 'id',
                    xs: 12,
                    disabled: true
                    // required: true
                }, {
                    type: FormItemTypes.SearchSelect,
                    label: 'Technician',
                    name: 'TechnicianId',
                    // options: technicianList ?? [],
                    getListData: getTechnicianList,
                    apiKey: 'technicianList',
                    apiRequest: {
                        WorkingOrganizationId: crud === null || crud === void 0 || (_crud$documentDetails = crud.documentDetailsGetById) === null || _crud$documentDetails === void 0 || (_crud$documentDetails = _crud$documentDetails.data) === null || _crud$documentDetails === void 0 ? void 0 : _crud$documentDetails.OrganizationId
                    },
                    getOptionLabel: function (option) { return option !== null && option !== void 0 && option.FirstName || option !== null && option !== void 0 && option.LastName ? (option === null || option === void 0 ? void 0 : option.FirstName) + " " + (option === null || option === void 0 ? void 0 : option.LastName) : ''; },
                    valueExpr: 'id',
                    displayExpr: 'FirstName'
                },
                // {
                //     type: FormItemTypes.SearchSelect,
                //     name: 'Bay',
                //     label: 'Bay',
                //     value: null,
                //     xs: 12,
                // },
                {
                    type: FormItemTypes.NumberInput,
                    name: 'Quantity',
                    label: 'Requested qty',
                    value: null,
                    xs: 6,
                    // required: true,
                    onFocus: function () {
                        dispatch(setReducerState({
                            key: JobCardKeys.DisableSubmit,
                            value: true
                        }));
                    },
                    validator: function (value) {
                        if (!value) {
                            return "Quantity is required";
                        }
                        if (Number(value) <= 0) {
                            "Quantity should be greater than 0";
                        }
                        if (Number(value) > 999999.99) {
                            return "Quantity cannot be greater than 999999.99";
                        }
                        return "";
                    },
                    onBlur: function (event, formValues, formApi) {
                        return __awaiter(this, void 0, void 0, function () {
                            var validationRules, _newPrice$payload, _newPrice$payload2, newPrice_1, _newPrice$payload3, _formValues$IssuedQua, _formValues$CancelQua, _formApi$handleInputC, updatedPrice_1, issuedQty, cancelQty, qty, pendingQty_1, setFormState;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!!(+(formValues === null || formValues === void 0 ? void 0 : formValues.Quantity) > 0)) return [3 /*break*/, 1];
                                        formApi === null || formApi === void 0 || formApi.setErrors(function (prev) {
                                            return _objectSpread(_objectSpread({}, prev), {}, {
                                                Quantity: "Quantity should be greater than 0",
                                                IsError: true
                                            });
                                        });
                                        return [3 /*break*/, 5];
                                    case 1:
                                        if (!(Number(formValues === null || formValues === void 0 ? void 0 : formValues.Quantity) > 999999.99)) return [3 /*break*/, 2];
                                        formApi === null || formApi === void 0 || formApi.setErrors(function (prev) {
                                            return _objectSpread(_objectSpread({}, prev), {}, {
                                                Quantity: "Quantity cannot be greater than 999999.99",
                                                IsError: true
                                            });
                                        });
                                        return [3 /*break*/, 5];
                                    case 2:
                                        validationRules = {
                                            0: REG.validateInteger,
                                            1: REG.validateDecimalUptoOneDigit,
                                            2: REG.validateDecimalAndNonNumeric
                                        };
                                        if (!((formValues === null || formValues === void 0 ? void 0 : formValues.DecimalPrecision) !== undefined && validationRules[formValues === null || formValues === void 0 ? void 0 : formValues.DecimalPrecision])) return [3 /*break*/, 5];
                                        if (!!validationRules[formValues === null || formValues === void 0 ? void 0 : formValues.DecimalPrecision].test(formValues === null || formValues === void 0 ? void 0 : formValues.Quantity)) return [3 /*break*/, 3];
                                        formApi === null || formApi === void 0 || formApi.setErrors(function (prev) {
                                            return _objectSpread(_objectSpread({}, prev), {}, {
                                                Quantity: (formValues === null || formValues === void 0 ? void 0 : formValues.DecimalPrecision) === 0 ? "Enter Qty in multiple of 1" : "Up to ".concat(formValues === null || formValues === void 0 ? void 0 : formValues.DecimalPrecision, " decimal precision is allowed"),
                                                IsError: true
                                            });
                                        });
                                        event.target.focus();
                                        return [3 /*break*/, 5];
                                    case 3: return [4 /*yield*/, validateQuantityAndGetTax(_objectSpread(_objectSpread({}, formValues), {}, {
                                            Quantity: Number(event.target.value)
                                        }), crud === null || crud === void 0 ? void 0 : crud.documentDetailsGetById, crud === null || crud === void 0 ? void 0 : crud.installbaseDetailsById)];
                                    case 4:
                                        newPrice_1 = _a.sent();
                                        if (newPrice_1 !== null && newPrice_1 !== void 0 && (_newPrice$payload = newPrice_1.payload) !== null && _newPrice$payload !== void 0 && (_newPrice$payload = _newPrice$payload.value) !== null && _newPrice$payload !== void 0 && _newPrice$payload.data && newPrice_1 !== null && newPrice_1 !== void 0 && (_newPrice$payload2 = newPrice_1.payload) !== null && _newPrice$payload2 !== void 0 && (_newPrice$payload2 = _newPrice$payload2.value) !== null && _newPrice$payload2 !== void 0 && _newPrice$payload2.success) {
                                            updatedPrice_1 = newPrice_1 === null || newPrice_1 === void 0 || (_newPrice$payload3 = newPrice_1.payload) === null || _newPrice$payload3 === void 0 || (_newPrice$payload3 = _newPrice$payload3.value) === null || _newPrice$payload3 === void 0 ? void 0 : _newPrice$payload3.data;
                                            issuedQty = (_formValues$IssuedQua = formValues === null || formValues === void 0 ? void 0 : formValues.IssuedQuantity) !== null && _formValues$IssuedQua !== void 0 ? _formValues$IssuedQua : 0;
                                            cancelQty = (_formValues$CancelQua = formValues === null || formValues === void 0 ? void 0 : formValues.CancelQuantity) !== null && _formValues$CancelQua !== void 0 ? _formValues$CancelQua : 0;
                                            qty = Number(event.target.value) - issuedQty;
                                            pendingQty_1 = qty - cancelQty;
                                            setFormState = function () {
                                                return {
                                                    SavedPriceWithTax: _objectSpread(_objectSpread({}, formValues === null || formValues === void 0 ? void 0 : formValues.SavedPriceWithTax), {}, {
                                                        "Taxes": updatedPrice_1.Taxes,
                                                        "Rate": updatedPrice_1.Rate,
                                                        "Quantity": updatedPrice_1.Quantity,
                                                        "Amount": updatedPrice_1.Amount,
                                                        "TaxableAmount": updatedPrice_1.TaxableAmount,
                                                        "BaseAmount": updatedPrice_1.BaseAmount
                                                    }),
                                                    MRP: updatedPrice_1 === null || updatedPrice_1 === void 0 ? void 0 : updatedPrice_1.MRP,
                                                    TaxableAmount: updatedPrice_1 === null || updatedPrice_1 === void 0 ? void 0 : updatedPrice_1.TaxableAmount,
                                                    Amount: updatedPrice_1 === null || updatedPrice_1 === void 0 ? void 0 : updatedPrice_1.Amount,
                                                    PendingQuantity: pendingQty_1 >= 0 ? pendingQty_1 : 0
                                                };
                                            };
                                            formApi === null || formApi === void 0 || (_formApi$handleInputC = formApi.handleInputChange) === null || _formApi$handleInputC === void 0 || _formApi$handleInputC.call(formApi, event, event.target.value, _objectSpread(_objectSpread({}, this), {}, {
                                                setFormState: setFormState
                                            }));
                                            formApi === null || formApi === void 0 || formApi.setErrors(function (prev) {
                                                return _objectSpread(_objectSpread({}, prev), {}, {
                                                    IsError: false,
                                                    Quantity: ""
                                                });
                                            });
                                        }
                                        else {
                                            formApi === null || formApi === void 0 || formApi.setErrors(function (prev) {
                                                var _newPrice$payload4;
                                                return _objectSpread(_objectSpread({}, prev), {}, {
                                                    Quantity: (newPrice_1 === null || newPrice_1 === void 0 || (_newPrice$payload4 = newPrice_1.payload) === null || _newPrice$payload4 === void 0 || (_newPrice$payload4 = _newPrice$payload4.value) === null || _newPrice$payload4 === void 0 ? void 0 : _newPrice$payload4.message) || "Something went wrong",
                                                    IsError: true
                                                });
                                            });
                                            event.target.focus();
                                        }
                                        _a.label = 5;
                                    case 5:
                                        dispatch(setReducerState({
                                            key: JobCardKeys.DisableSubmit,
                                            value: false
                                        }));
                                        return [2 /*return*/];
                                }
                            });
                        });
                    }
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    columnSize: 6,
                    elements: [{
                            type: FormItemTypes.Box,
                            name: '',
                            display: 'flex',
                            justifyContent: 'space-between',
                            columnSize: 12,
                            mb: 0.5,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'IssuedQuantity',
                                    children: 'Issued Quantity',
                                    columnSize: 0,
                                    fontSize: 'sm',
                                    color: 'text.secondary',
                                    fontWeight: 'medium'
                                }, {
                                    type: FormItemTypes.IconButton,
                                    name: '',
                                    setFieldProps: function () {
                                        return {
                                            disabled: false
                                        };
                                    },
                                    children: /*#__PURE__*/ React.createElement(SvgIcon, {
                                        color: "primary",
                                        sx: {
                                            height: 20,
                                            width: 20
                                        }
                                    }, /*#__PURE__*/ React.createElement(InfoOutlined, null)),
                                    columnSize: 0,
                                    sx: {
                                        p: 0
                                    },
                                    onClick: function (e, state) { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            dispatch(showSurface({
                                                type: 'Drawer',
                                                Component: IssuedQtyPopup,
                                                containerProps: {
                                                    PaperProps: {
                                                        sx: {
                                                            px: 0.5,
                                                            width: {
                                                                xs: '100%'
                                                            },
                                                            borderRadius: '8px 8px 0 0'
                                                        }
                                                    },
                                                    anchor: 'bottom'
                                                },
                                                componentProps: {
                                                    data: state
                                                }
                                            }));
                                            return [2 /*return*/];
                                        });
                                    }); },
                                    unsubscribeFormChange: true
                                }]
                        }, {
                            type: FormItemTypes.NumberInput,
                            name: 'IssuedQuantity',
                            label: '',
                            columnSize: 0,
                            disabled: true
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.NumberInput,
                            name: 'Rate',
                            label: 'Rate',
                            value: null,
                            disabled: true,
                            xs: 6,
                            valueGetter: function (formValues, field) {
                                var _formValues$SavedPric;
                                return formValues === null || formValues === void 0 || (_formValues$SavedPric = formValues.SavedPriceWithTax) === null || _formValues$SavedPric === void 0 ? void 0 : _formValues$SavedPric.Rate;
                            },
                            setFormState: function (formValues, value) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    return [2 /*return*/, {
                                            SavedPriceWithTax: _objectSpread(_objectSpread({}, formValues === null || formValues === void 0 ? void 0 : formValues.SavedPriceWithTax), {}, {
                                                Rate: value
                                            })
                                        }];
                                });
                            }); },
                            onBlur: function (event, formValues, formApi) {
                                return __awaiter(this, void 0, void 0, function () {
                                    var _newPrice$payload5, _newPrice$payload6, newPrice, _newPrice$payload7, _formApi$handleInputC2, updatedPrice_2, setFormState;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, validateQuantityAndGetTax(_objectSpread(_objectSpread({}, formValues), {}, {
                                                    Rate: Number(event.target.value)
                                                }), crud === null || crud === void 0 ? void 0 : crud.documentDetailsGetById, crud === null || crud === void 0 ? void 0 : crud.installbaseDetailsById)];
                                            case 1:
                                                newPrice = _a.sent();
                                                if (newPrice !== null && newPrice !== void 0 && (_newPrice$payload5 = newPrice.payload) !== null && _newPrice$payload5 !== void 0 && (_newPrice$payload5 = _newPrice$payload5.value) !== null && _newPrice$payload5 !== void 0 && _newPrice$payload5.data && newPrice !== null && newPrice !== void 0 && (_newPrice$payload6 = newPrice.payload) !== null && _newPrice$payload6 !== void 0 && (_newPrice$payload6 = _newPrice$payload6.value) !== null && _newPrice$payload6 !== void 0 && _newPrice$payload6.success) {
                                                    updatedPrice_2 = newPrice === null || newPrice === void 0 || (_newPrice$payload7 = newPrice.payload) === null || _newPrice$payload7 === void 0 || (_newPrice$payload7 = _newPrice$payload7.value) === null || _newPrice$payload7 === void 0 ? void 0 : _newPrice$payload7.data;
                                                    setFormState = function () {
                                                        return {
                                                            SavedPriceWithTax: _objectSpread(_objectSpread({}, formValues === null || formValues === void 0 ? void 0 : formValues.SavedPriceWithTax), {}, {
                                                                "Taxes": updatedPrice_2.Taxes,
                                                                "Rate": updatedPrice_2.Rate,
                                                                "Quantity": updatedPrice_2.Quantity,
                                                                "Amount": updatedPrice_2.Amount,
                                                                "TaxableAmount": updatedPrice_2.TaxableAmount,
                                                                "BaseAmount": updatedPrice_2.BaseAmount
                                                            }),
                                                            MRP: updatedPrice_2 === null || updatedPrice_2 === void 0 ? void 0 : updatedPrice_2.MRP,
                                                            TaxableAmount: updatedPrice_2 === null || updatedPrice_2 === void 0 ? void 0 : updatedPrice_2.TaxableAmount,
                                                            Amount: updatedPrice_2 === null || updatedPrice_2 === void 0 ? void 0 : updatedPrice_2.Amount
                                                        };
                                                    };
                                                    formApi === null || formApi === void 0 || (_formApi$handleInputC2 = formApi.handleInputChange) === null || _formApi$handleInputC2 === void 0 || _formApi$handleInputC2.call(formApi, event, event.target.value, _objectSpread(_objectSpread({}, this), {}, {
                                                        setFormState: setFormState
                                                    }));
                                                    formApi === null || formApi === void 0 || formApi.setErrors(function (prev) {
                                                        return _objectSpread(_objectSpread({}, prev), {}, {
                                                            IsError: false,
                                                            Rate: ""
                                                        });
                                                    });
                                                }
                                                else {
                                                    formApi === null || formApi === void 0 || formApi.setErrors(function (prev) {
                                                        var _newPrice$payload8;
                                                        return _objectSpread(_objectSpread({}, prev), {}, {
                                                            Rate: (newPrice === null || newPrice === void 0 || (_newPrice$payload8 = newPrice.payload) === null || _newPrice$payload8 === void 0 || (_newPrice$payload8 = _newPrice$payload8.value) === null || _newPrice$payload8 === void 0 ? void 0 : _newPrice$payload8.message) || "Something went wrong",
                                                            IsError: true
                                                        });
                                                    });
                                                }
                                                return [2 /*return*/];
                                        }
                                    });
                                });
                            },
                            setFieldProps: function (state, currValue, field) {
                                return {
                                    disabled: true,
                                    onChange: function () { }
                                };
                            }
                        }, {
                            type: FormItemTypes.SearchSelect,
                            name: 'MRP',
                            label: 'MRP',
                            // value: null,
                            xs: 6,
                            valueGetter: function (formValues, value) {
                                var _formValues$SavedPric2, _formValues$SavedPric3;
                                return (_formValues$SavedPric2 = formValues === null || formValues === void 0 || (_formValues$SavedPric3 = formValues.SavedPriceWithTax) === null || _formValues$SavedPric3 === void 0 ? void 0 : _formValues$SavedPric3.MRP) !== null && _formValues$SavedPric2 !== void 0 ? _formValues$SavedPric2 : 0;
                            },
                            valueExpr: 'MRP',
                            displayExpr: "MRP",
                            setFormState: function (formValues, current) {
                                return {
                                    SavedPriceWithTax: current,
                                    MRP: current === null || current === void 0 ? void 0 : current.MRP,
                                    TaxableAmount: current === null || current === void 0 ? void 0 : current.TaxableAmount,
                                    Amount: current === null || current === void 0 ? void 0 : current.Amount,
                                    Rate: current === null || current === void 0 ? void 0 : current.Rate
                                };
                            },
                            setFieldProps: function (state, currValue, field) {
                                return {
                                    type: FormItemTypes.SearchSelect,
                                    disabled: (currValue === null || currValue === void 0 ? void 0 : currValue.PriceGroupCategoryKey) !== "MRP",
                                    options: (state === null || state === void 0 ? void 0 : state.PriceWithTaxList) || []
                                };
                            }
                        }]
                },
                //2.5.1
                // {
                //     type: FormItemTypes.NumberInput,
                //     name: 'TradeDiscountPercentage',
                //     label: 'Trade Discount (₹) :',
                //     value: null,
                //     disabled: true,
                //     xs: 6,
                //     InputProps: {
                //         endAdornment: <SvgIcon sx={{ height: 20, width: 20 }}>
                //             <DeviderIcon />
                //         </SvgIcon>
                //     }
                // },
                // {
                //     type: FormItemTypes.NumberInput,
                //     name: 'TradeDiscountAmount',
                //     label: '',
                //     value: null,
                //     disabled: true,
                //     sx: { marginTop: '22px' },
                //     xs: 6,
                //     InputProps: {
                //         endAdornment: <SvgIcon sx={{ height: 20, width: 20 }}>
                //             <RupeeIcon />
                //         </SvgIcon>
                //     }
                // },
                {
                    type: FormItemTypes.NumberInput,
                    name: 'TaxableAmount',
                    label: 'Taxable amount (₹) ',
                    value: null,
                    xs: 6,
                    disabled: true
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    columnSize: 6,
                    elements: [{
                            type: FormItemTypes.Box,
                            name: '',
                            display: 'flex',
                            justifyContent: 'space-between',
                            columnSize: 12,
                            mb: 0.4,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    children: 'Total taxes (₹)',
                                    columnSize: 0,
                                    fontSize: 'sm',
                                    color: 'text.secondary',
                                    fontWeight: 'medium'
                                }, {
                                    type: FormItemTypes.IconButton,
                                    name: '',
                                    children: /*#__PURE__*/ React.createElement(SvgIcon, {
                                        color: "primary",
                                        sx: {
                                            height: 20,
                                            width: 20
                                        }
                                    }, /*#__PURE__*/ React.createElement(InfoOutlined, null)),
                                    columnSize: 0,
                                    sx: {
                                        p: 0
                                    },
                                    setFieldProps: function () {
                                        return {
                                            disabled: false
                                        };
                                    },
                                    onClick: function (e, state) { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            dispatch(showSurface({
                                                type: 'Drawer',
                                                Component: TaxDetailsPopup,
                                                containerProps: {
                                                    PaperProps: {
                                                        sx: {
                                                            px: 0.5,
                                                            width: {
                                                                xs: '100%'
                                                            },
                                                            borderRadius: '8px 8px 0 0'
                                                        }
                                                    },
                                                    anchor: 'bottom'
                                                },
                                                componentProps: {
                                                    data: state
                                                }
                                            }));
                                            return [2 /*return*/];
                                        });
                                    }); },
                                    unsubscribeFormChange: true
                                }]
                        }, {
                            type: FormItemTypes.NumberInput,
                            name: 'Totaltaxes',
                            label: '',
                            columnSize: 0,
                            disabled: true,
                            sx: {
                                p: 0
                            },
                            valueGetter: function (formValues, field) {
                                var _formValues$SavedPric4;
                                var totalTax = 0;
                                formValues === null || formValues === void 0 || (_formValues$SavedPric4 = formValues.SavedPriceWithTax) === null || _formValues$SavedPric4 === void 0 || (_formValues$SavedPric4 = _formValues$SavedPric4.Taxes) === null || _formValues$SavedPric4 === void 0 || _formValues$SavedPric4.forEach(function (taxItem) {
                                    totalTax += taxItem.TaxComponentAmount;
                                });
                                var displayValue = totalTax > 0 ? totalTax.toFixed(2) : 0;
                                return displayValue;
                            }
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    // display: 'flex',
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.Box,
                            name: '',
                            display: 'flex',
                            justifyContent: 'space-between',
                            columnSize: 12,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'Price',
                                    children: 'Amount',
                                    columnSize: 0,
                                    color: 'text.secondary',
                                    fontSize: 'sm',
                                    fontWeight: 'medium'
                                }, {
                                    type: FormItemTypes.Button,
                                    name: '',
                                    variant: 'text',
                                    children: 'Ratio',
                                    columnSize: 0,
                                    sx: {
                                        pt: 0
                                    },
                                    onClick: function (e, formValues, api) {
                                        var _crud$documentDetails2;
                                        handleRatioDetailsPopup(formValues, crud === null || crud === void 0 || (_crud$documentDetails2 = crud.documentDetailsGetById) === null || _crud$documentDetails2 === void 0 || (_crud$documentDetails2 = _crud$documentDetails2.data) === null || _crud$documentDetails2 === void 0 ? void 0 : _crud$documentDetails2.RepairTypeId);
                                    },
                                    setFieldProps: function (formValues, currValue) {
                                        var _formValues$RatioBill;
                                        return {
                                            disabled: false,
                                            sx: {
                                                display: ((_formValues$RatioBill = formValues.RatioBilling) === null || _formValues$RatioBill === void 0 ? void 0 : _formValues$RatioBill.length) > 0 ? 'inline-flex' : 'none',
                                                pt: 0
                                            }
                                        };
                                    }
                                }]
                        }, {
                            type: FormItemTypes.NumberInput,
                            name: 'Amount',
                            value: null,
                            placeholder: 'Enter Amount',
                            xs: 12,
                            disabled: true
                        }]
                }
                //2.5.1
                // {
                //     type: FormItemTypes.Box,
                //     name: '',
                //     display: 'flex',
                //     justifyContent: 'end',
                //     gap: '16px',
                //     columnSize: 12,
                //     elements: [
                //         {
                //             type: FormItemTypes.Button,
                //             name: '',
                //             variant: 'outlined',
                //             children: 'Checksheet',
                //             columnSize: 0,
                //             onClick: async () => {
                //                 const result = await dispatch(showSurface({
                //                     type: 'Drawer',
                //                     Component: ChecklistDetailsPopup,
                //                     containerProps: {
                //                         anchor: 'bottom',
                //                         PaperProps: {
                //                             sx: {
                //                                 borderRadius: '8px 8px 0 0'
                //                             }
                //                         }
                //                     },
                //                 }));
                //             }
                //         },
                //         {
                //             type: FormItemTypes.Button,
                //             name: '',
                //             variant: 'outlined',
                //             children: 'View more',
                //             columnSize: 0,
                //             setFormState: async (state) => {
                //                 const res = await dispatch(showSurface({
                //                     type: 'Drawer',
                //                     Component: PartMoreDetails,
                //                     containerProps: {
                //                         anchor: 'bottom',
                //                         PaperProps: {
                //                             sx: {
                //                                 borderRadius: '8px 8px 0 0'
                //                             }
                //                         }
                //                     },
                //                     componentProps: {
                //                         data: state,
                //                     }
                //                 }));
                //                 if (res?.payload) {
                //                     return {
                //                         ...res?.payload
                //                     }
                //                 }
                //             }
                //         }],
                // },
            ],
            columnSize: 12
        }];
    return partElements;
}
